import { Grid2 as Grid } from '@mui/material';
import React, { useCallback } from 'react';
import { Button } from 'framework/ui/mui-builder';
import { useFormContext } from 'framework/form';

const BillingRequestActionButtons = () => {
  const { data = {}, isSubmitEnabled, submitForm } = useFormContext();

  const submit = useCallback(
    (isDraft: boolean) => {
      data.isDraft = isDraft;
      submitForm?.();
    },
    [data, submitForm],
  );

  return (
    <Grid container direction="row" spacing={1} sx={{ justifyContent: 'end', alignItems: 'center' }}>
      <Grid>
        <Button variant="outlined" disabled={!isSubmitEnabled} onClick={() => submit(true)}>
          Save as draft
        </Button>
      </Grid>
      <Grid>
        <Button disabled={!isSubmitEnabled} onClick={() => submit(false)}>
          Send for approval
        </Button>
      </Grid>
    </Grid>
  );
};

export default BillingRequestActionButtons;
